import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import AddChannel from "./AddChannel"
import EditChannel from "./EditChannel"
import ChannelList from "./ChannelList"

 class Index extends Component {
   constructor(props) {
     super(props);
     this.state = {
       routeStatus:0,
       dataValue: {},
     };
   }

   changeStatus = (type) => {
     this.setState({
       routeStatus: type,
     });
   };

   changeStatusWithStatusValue = (type, dataValue) => {
     this.setState({
       routeStatus: type,
       dataValue,
     });
   };

   render() {
     const { routeStatus, dataValue } = this.state;
     return (
       <div className="wrapper position-relative">
         {routeStatus == 0 && (
           <ChannelList
             changeStatusWithStatusValue={this.changeStatusWithStatusValue}
           />
         )}

         {routeStatus == 1 && <AddChannel changeRouteStatus={this.changeStatus} />}

         {routeStatus == 2 && (
           <EditChannel changeRouteStatus={this.changeStatus} item={dataValue} />
         )}
       </div>
     );
   }
 }
export default (withRouter(Index));